import get from "lodash.get";
import { toast } from "react-toastify";

import GlobalFiltersActioner from "services/globalFilters/actioner";
import IntlUtils from "services/intl/utils";

class AbstractApiActioner {
  constructor(storeName, actionTypes, api, utils, config) {
    this.storeName = storeName;
    this.actionTypes = actionTypes;
    this.api = api;
    this.utils = utils;
    this.config = config; // extra config (ex: custom paths)
  }

  setInitialized(store, value) {
    return {
      type: this.actionTypes.SET_INITIALIZED,
      store,
      value,
    };
  }

  setFilters(data) {
    return {
      type: this.actionTypes.SET_FILTERS,
      data,
    };
  }

  setFilter(key, value) {
    return {
      type: this.actionTypes.SET_FILTER,
      key,
      value,
    };
  }

  setHoverIndex(value) {
    return {
      type: this.actionTypes.SET_LIST_HOVER_INDEX,
      value,
    };
  }

  setOrders(value) {
    return {
      type: this.actionTypes.SET_LIST_ORDERS,
      value,
    };
  }

  setList(list) {
    return {
      type: this.actionTypes.SET_LIST,
      value: list,
    };
  }

  setSelectedIndex(value) {
    return {
      type: this.actionTypes.SET_LIST_SELECTED_INDEX,
      value,
    };
  }

  // Check if some required filters are missing
  missingRequiredFilters(type = "default", filters) {
    if (
      type === "areas" &&
      (!get(filters, "areas") ||
        !get(filters, "timestamp") ||
        get(filters, "timestamp") < 0)
    ) {
      return true;
    }

    if (
      type === "radius" &&
      (!get(filters, "radius") ||
        get(filters, "radius") <= 0 ||
        !get(filters, "position") ||
        !get(filters, "position.lat") ||
        !get(filters, "position.lng"))
    ) {
      return true;
    }

    return false;
  }

  retrieveList(type = "default") {
    return (dispatch, getState) => {
      let filters = this.utils.getFilters(type, getState());
      const ParkStatisticsState = getState().ParkStatistics;
      const listName = this.utils.getListNameFromType(type);

      if (this.missingRequiredFilters(type, filters)) {
        const formattedList = this.utils.formatListFromApi([]);
        dispatch(this.setList(formattedList));
        return Promise.resolve(formattedList);
      }

      if (!get(ParkStatisticsState, "autoRefresh", false)) {
        dispatch(this.setInitialized("list", false));
      }

      if (type === "radius" || type === "default") {
        const contractId = getState().Contract.contract.id;
        filters = {
          ...filters,
          contract_id: contractId,
        };
      }

      return get(this.api, listName, () => Promise.resolve())(filters)
        .then((list) => {
          const formattedList = this.utils.formatListFromApi(list);
          const apiTimestamp = this.utils.getApiTimestamp(list);

          if (
            [
              "NonMovingCars",
              "HeatmapOccupancy",
              "ParkedCars",
              "AvailableParking",
            ].indexOf(this.storeName) < 0 &&
            apiTimestamp
          ) {
            dispatch(
              GlobalFiltersActioner.setParameter(
                "timestamp",
                apiTimestamp,
                false
              )
            );
          }
          return dispatch(this.setList(formattedList));
        })
        .catch((error) => {
          const intl = IntlUtils.getIntlInstance();
          let msg = intl.messages["toast.errors.errorOccuredContactSupport"];
          if (error.status === 403) {
            switch (this.storeName) {
              case "Displays":
                msg = intl.formatMessage({
                  id: "toast.errors.displays.resource",
                });
                break;
              default:
                break;
            }
          }

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
          const formattedList = this.utils.formatListFromApi([]);
          dispatch(this.setList(formattedList));

          return Promise.resolve(formattedList);
        });
    };
  }
}

export default AbstractApiActioner;
